/**
 * UJ Variant Swatches
 * Ürün sayfasında resimli variant swatch'ları oluşturur.
 * Custom liquid'deki Liquid kodu case-sensitive eşleşme yapıyor,
 * bu JS client-side'da case-insensitive çalışarak tüm opsiyonları yakalar.
 * Mevcut pd-fp CSS class'larını kullanır (custom liquid'deki CSS ile uyumlu).
 * Build: sticky-mini-v5 — title yanında 90x90 + Case column hidden
 */
(function() {
  'use strict';

  // Main area zaten Liquid tarafından oluşturulduysa o kısmı atla, sticky-atc için yine de devam et
  var mainAlreadyRendered = !!document.getElementById('pd-product-swatch-wrapper');

  // Color opsiyonu var mı kontrol et (case-insensitive)
  var colorTriggers = ['color', 'colour', 'renk', 'style'];
  var productUrl = window.location.pathname + '.js';

  fetch(productUrl)
    .then(function(res) { return res.json(); })
    .then(function(product) {
      if (!product.options || !product.variants) return;

      var colorOption = null;
      var colorOptionIndex = -1;

      for (var i = 0; i < product.options.length; i++) {
        var optName = product.options[i].name.toLowerCase();
        for (var t = 0; t < colorTriggers.length; t++) {
          if (optName.indexOf(colorTriggers[t]) !== -1) {
            colorOption = product.options[i];
            colorOptionIndex = i;
            break;
          }
        }
        if (colorOption) break;
      }

      if (!colorOption) return;

      // Her değer için ilk eşleşen variant'ı bul
      var valueMap = [];
      for (var v = 0; v < colorOption.values.length; v++) {
        var val = colorOption.values[v];
        var matchedVariant = null;
        for (var j = 0; j < product.variants.length; j++) {
          var optKey = 'option' + (colorOptionIndex + 1);
          if (product.variants[j][optKey] === val) {
            matchedVariant = product.variants[j];
            break;
          }
        }
        if (matchedVariant) {
          var imgSrc = '';
          var thumbSrc = '';
          if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
            imgSrc = matchedVariant.featured_image.src;
            // Thumbnail için küçük boyut
            thumbSrc = imgSrc.replace(/(\.\w+)\?/, '_200x200_crop_center$1?');
          } else if (product.featured_image) {
            imgSrc = product.featured_image;
            thumbSrc = imgSrc.replace(/(\.\w+)\?/, '_200x200_crop_center$1?');
          }
          valueMap.push({
            value: val,
            variantId: matchedVariant.id,
            imageSrc: imgSrc,
            thumbSrc: thumbSrc || imgSrc,
            mediaId: matchedVariant.featured_media ? matchedVariant.featured_media.id : null
          });
        }
      }

      if (valueMap.length === 0) return;

      // URL'den aktif variant'ı bul
      var urlParams = new URLSearchParams(window.location.search);
      var urlVariant = urlParams.get('variant');
      var activeValue = colorOption.values[0];
      if (urlVariant) {
        for (var k = 0; k < valueMap.length; k++) {
          if (String(valueMap[k].variantId) === urlVariant) {
            activeValue = valueMap[k].value;
            break;
          }
        }
      }

      // Main area — yalnızca Liquid tarafından oluşturulmamışsa enjekte et
      if (!mainAlreadyRendered) { buildMainSwatches(); }

      // Sticky-atc — her zaman dene (ayrı enjeksiyon)
      buildStickyAtcSwatches();
      return;

      function buildMainSwatches() {
      // Swatch HTML oluştur
      var wrapper = document.createElement('div');
      wrapper.className = 'pd-fp-swatch-wrapper';
      wrapper.id = 'pd-product-swatch-wrapper';

      var label = document.createElement('span');
      label.className = 'pd-fp-label';
      label.innerHTML = colorOption.name + ': <span id="pd-fp-selected-val" style="font-weight:400;color:#666;">' + activeValue + '</span>';
      wrapper.appendChild(label);

      var list = document.createElement('div');
      list.className = 'pd-fp-list';

      for (var m = 0; m < valueMap.length; m++) {
        var item = valueMap[m];
        var div = document.createElement('div');
        div.className = 'pd-fp-item' + (item.value === activeValue ? ' active' : '');
        div.title = item.value;
        div.setAttribute('data-value', item.value);
        div.setAttribute('data-variant-id', item.variantId);
        div.setAttribute('data-variant-image', item.imageSrc);
        if (item.mediaId) {
          div.setAttribute('data-media-id', item.mediaId);
        }
        div.onclick = function() { handleSwatchClick(this); };

        var img = document.createElement('img');
        img.src = item.thumbSrc;
        img.alt = item.value;
        img.loading = 'lazy';
        div.appendChild(img);
        list.appendChild(div);
      }

      wrapper.appendChild(list);

      // Ana ürün alanını scope et — sticky-atc (footer) dışlanmalı, yoksa swatch'lar
      // footer'a enjekte olup 300px yüksekliğinde sticky bar'a sebep olur.
      var scope = document.querySelector('product-info') || document;

      function outsideStickyAtc(el) {
        return el && !el.closest('sticky-atc');
      }

      // Öncelik: ana product-form__input (sticky-atc dışında)
      var insertTarget = null;
      var candidates = scope.querySelectorAll('.product-form__input');
      for (var c = 0; c < candidates.length; c++) {
        if (outsideStickyAtc(candidates[c])) { insertTarget = candidates[c]; break; }
      }

      // Fallback: quantity-breaks veya ana form
      if (!insertTarget) {
        var fallbacks = [
          'quantity-breaks',
          '.main-product-form [data-product-form]',
          '.main-product-form .product-form__buttons',
          '.main-product-form',
          '[data-product-form]',
          '.product-form__buttons'
        ];
        for (var f = 0; f < fallbacks.length; f++) {
          var el = scope.querySelector(fallbacks[f]);
          if (outsideStickyAtc(el)) { insertTarget = el; break; }
        }
      }

      if (insertTarget) {
        var parent = insertTarget.parentElement;
        parent.insertBefore(wrapper, insertTarget);
      }

      // Click handler
      function handleSwatchClick(el) {
        // pdHandleClick mevcutsa onu kullan (custom liquid JS)
        if (typeof window.pdHandleClick === 'function') {
          window.pdHandleClick(el);
          return;
        }

        // Standalone handler
        var items = el.parentElement.querySelectorAll('.pd-fp-item');
        for (var i = 0; i < items.length; i++) items[i].classList.remove('active');
        el.classList.add('active');

        var val = el.getAttribute('data-value');
        var varId = el.getAttribute('data-variant-id');

        // Label güncelle
        var selLabel = document.getElementById('pd-fp-selected-val');
        if (selLabel) selLabel.innerText = val;

        // URL güncelle
        if (varId) {
          window.history.replaceState(null, '', window.location.pathname + '?variant=' + varId);
        }

        // Native picker sync
        var section = el.closest('product-info') || el.closest('[id^="shopify-section-"]') || document;
        var radios = section.querySelectorAll('.product-form__input input[type="radio"]');
        radios.forEach(function(radio) {
          if (radio.value === val) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Cart form güncelle
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        forms.forEach(function(form) {
          var inp = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
          if (inp) {
            inp.value = varId;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Media gallery güncelle
        var mid = el.getAttribute('data-media-id');
        if (mid) {
          var mg = document.querySelector('media-gallery');
          if (mg && typeof mg.setActiveMedia === 'function') {
            var sid = mg.dataset.section || '';
            var fullId = sid ? sid + '-' + mid : String(mid);
            var mediaItem = mg.querySelector('[data-media-id="' + fullId + '"]');
            if (!mediaItem) mediaItem = mg.querySelector('[data-media-id$="-' + mid + '"]');
            if (mediaItem) mg.setActiveMedia(mediaItem.dataset.mediaId, true);
          }
        }
      }

      // Sayfa yüklendiğinde URL variant'ı varsa medyayı güncelle
      if (urlVariant) {
        var activeItem = wrapper.querySelector('.pd-fp-item[data-variant-id="' + urlVariant + '"]');
        if (activeItem) {
          var mid = activeItem.getAttribute('data-media-id');
          if (mid) {
            function setInitMedia() {
              var mg = document.querySelector('media-gallery');
              if (!mg || typeof mg.setActiveMedia !== 'function') return;
              var sid = mg.dataset.section || '';
              var fullId = sid ? sid + '-' + mid : String(mid);
              var mi = mg.querySelector('[data-media-id="' + fullId + '"]');
              if (!mi) mi = mg.querySelector('[data-media-id$="-' + mid + '"]');
              if (mi) mg.setActiveMedia(mi.dataset.mediaId, true);
            }
            if (window.customElements && window.customElements.whenDefined) {
              window.customElements.whenDefined('media-gallery').then(function() {
                setTimeout(setInitMedia, 200);
              });
            }
          }
        }
      }
      } // end buildMainSwatches

      function buildStickyAtcSwatches() {
        var sticky = document.querySelector('sticky-atc');
        if (!sticky) return;
        var picker = sticky.querySelector('secondary-variant-select-separate') || sticky;

        // Color option name case-insensitive olarak select[name]'de eşleşiyor mu?
        var selects = picker.querySelectorAll('select.select__select');
        if (!selects.length) return;

        var targetSelect = null;
        var targetParent = null;
        for (var si = 0; si < selects.length; si++) {
          var nm = (selects[si].getAttribute('name') || '').toLowerCase();
          if (nm.indexOf(colorOption.name.toLowerCase()) !== -1) {
            targetSelect = selects[si];
            targetParent = targetSelect.closest('.product-form__input');
            break;
          }
        }
        if (!targetSelect || !targetParent) return;
        if (targetParent.querySelector('.uj-sticky-swatch')) return; // zaten eklenmiş

        var miniWrap = document.createElement('div');
        miniWrap.className = 'uj-sticky-swatch';
        miniWrap.setAttribute('role', 'radiogroup');
        miniWrap.setAttribute('aria-label', colorOption.name);

        for (var k = 0; k < valueMap.length; k++) {
          (function(item) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'uj-sticky-swatch__item' + (item.value === activeValue ? ' is-active' : '');
            btn.setAttribute('data-value', item.value);
            btn.setAttribute('data-variant-id', item.variantId);
            btn.setAttribute('aria-label', item.value);
            btn.title = item.value;
            var thumb = document.createElement('img');
            thumb.src = item.thumbSrc;
            thumb.alt = item.value;
            thumb.loading = 'lazy';
            btn.appendChild(thumb);
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              if (targetSelect.value !== item.value) {
                targetSelect.value = item.value;
                targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
              var all = miniWrap.querySelectorAll('.uj-sticky-swatch__item');
              for (var a = 0; a < all.length; a++) all[a].classList.remove('is-active');
              btn.classList.add('is-active');
            });
            miniWrap.appendChild(btn);
          })(valueMap[k]);
        }

        // Native select'i ve tüm Case column'unu gizle (kalan border/çizgi önlensin)
        // select DOM'da kalır → secondary-variant-select-separate hâlâ okuyabilir
        targetSelect.style.display = 'none';
        targetParent.style.display = 'none';
        var caret = targetParent.querySelector('.icon-caret');
        if (caret) caret.style.display = 'none';
        // Picker grid'ini güncelle — kalan dropdown sayısı (Rainbow: Case Size = 1; tek eksenli ürünler: 0 → 1). 2026-09-26: taş ekseni kaldırıldı.
        if (picker && picker.style) {
          var remaining = picker.querySelectorAll('select').length - 1;
          try { picker.style.setProperty('--options-count', String(remaining > 0 ? remaining : 1)); } catch (e) {}
        }
        // Mini swatch + kalan picker (Rainbow: Case Size) yan yana: leftBox flex row, order [title, mini, picker]
        // CSS CDN cache'ine bağımlı olmadan JS'ten flex uygula
        var leftBox = sticky.querySelector('.sticky-atc__left');
        if (leftBox) {
          leftBox.style.display = 'flex';
          leftBox.style.alignItems = 'center';
          leftBox.style.gap = '12px';
          leftBox.style.flexWrap = 'nowrap';
          var leftContentEl = leftBox.querySelector('.sticky-atc__left__content');
          // DOM append — miniWrap leftBox içine taşınır
          leftBox.appendChild(miniWrap);
          // Inline flex order — CDN cache'den bağımsız kesin sıralama
          if (leftContentEl) { leftContentEl.style.order = '1'; leftContentEl.style.flex = '0 0 auto'; }
          miniWrap.style.order = '2';
          miniWrap.style.flex = '0 0 auto';
          if (picker && picker.style) {
            picker.style.order = '3';
            picker.style.marginLeft = '0';
            picker.style.flex = '0 0 auto';
          }
        } else {
          targetParent.appendChild(miniWrap);
        }

        // Dışarıdan select değişirse mini swatch'ı senkronla
        targetSelect.addEventListener('change', function() {
          var val = targetSelect.value;
          var items = miniWrap.querySelectorAll('.uj-sticky-swatch__item');
          for (var i = 0; i < items.length; i++) {
            items[i].classList.toggle('is-active', items[i].getAttribute('data-value') === val);
          }
        });
      }
    })
    .catch(function(err) {
      console.log('[UJ] swatches error:', err);
    });
})();
// cache-bust: 20260926-restructure
